import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {
    private dataClient: any;
    private date: any;
    private contractId: any;
    private tipoAlta: any;
    private muestraComentarios: BehaviorSubject<boolean>;
    
    constructor() {
        this.dataClient = new BehaviorSubject<any>(null);
        this.date = new BehaviorSubject<any>(null);
        this.contractId = new BehaviorSubject<any>(null);
        this.muestraComentarios = new BehaviorSubject<boolean>(false);
        this.tipoAlta = new BehaviorSubject<any>(null);
    }

    // Enviamos los datos del cliente necesarios para el componente de cliente
    getDataClient(){
        return this.dataClient.asObservable();
    }

    // Enviamos fecha generada al entrar en el componente de confirmation
    getDateClient(){
        return this.date.asObservable();
    }

    // Enviamos el número de contrato
    getContractId(){
        return this.contractId.asObservable();
    }

    // Recuperamos valor para saber si mostrar o no los comentarios, por defecto es false
    getMuestraComentarios(){
        return this.muestraComentarios.asObservable();
    }

    // Retornamos sting con el tipo de alta
    getTipoAlta(){
        return this.tipoAlta.asObservable();
    }

    // Añadimos los datos del cliente que se usan en el componente de cliente
    setDataClient(value){
        this.dataClient.next(value);
    }

    // Añadimos fecha generada al entrar en el componente de confirmation
    setDateClient(value){
        this.date.next(value);
    }

    // Añadimos el número de contrato
    setContractId(value){
        this.contractId.next(value);
    }

    // Cambiamos la visibilidad de los comentarios en el componente
    setMuestraComentarios(value){
        this.muestraComentarios.next(value);
    }

    // Montamos el string para mostrar el tipo de alta
    setTipoAlta(value){
        let tipoAltaFijo: string = null;
        let tipoAltaMovil: string = null;

        if(value.hasOwnProperty('formularioResultadoCobertura') && value.formularioResultadoCobertura !== null) {
            tipoAltaFijo = value.formularioResultadoCobertura.get('tipoAltaFijo').value === 'portability' ? 'Portabilidad fijo + ' : 'Alta fijo + ';
            if (value.formularioResultadoCobertura.get('tipoAltaFijo').value === 'migration') {
                tipoAltaFijo = 'Migración fijo + ';
            }
        }

        tipoAltaMovil = value.itemForms[0].get('type_operation').value !== '' && value.itemForms[0].get('type_operation').value.includes("portability") ? 'Portabilidad móvil' : 'Alta móvil';
        if (value.itemForms[0].get('type_operation').value === 'migration') {
            tipoAltaMovil = 'Migración móvil';
        }

        if(tipoAltaFijo !== null){
            this.tipoAlta.next(tipoAltaFijo + tipoAltaMovil);
        }else{
            this.tipoAlta.next(tipoAltaMovil);
        }
    }

}
